// extracted by mini-css-extract-plugin
export default {"wrapper":"Signin_wrapper__LKSEr"};